/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function deepMerge(target: any, ...sources: any[]): any {
	if (!target || !sources.length) {
		return target;
	}
	const source = sources.shift();

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) {
					Object.assign(target, { [key]: {} });
				}
				deepMerge(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		}
	}
	return deepMerge(target, ...sources);
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item: unknown): boolean {
	return !!item && typeof item === 'object' && !Array.isArray(item);
}
